import React from "react";
import { Tooltip } from "@/components/common/Tooltip";

export interface PrincipalProps {
  /// The raw identity as recorded — shown when nothing resolved, because an
  /// audit row must still say who even after the account is gone.
  id: string;
  name: string | null;
  email: string | null;
  kind?: "user" | "team" | null;
}

/// A person or team in an audit row: the name, with the exact identity in a
/// tooltip. Falls back to the raw id, never to "Unknown".
export const Principal: React.FC<PrincipalProps> = ({
  id,
  name,
  email,
  kind,
}) => {
  const label = name || email || id;
  const exact = kind === "team" ? `Team · ${id}` : email || id;
  if (label === exact) {
    return <span className="text-fg-regular">{label}</span>;
  }
  return (
    <Tooltip title={exact}>
      <span className="cursor-default text-fg-regular">{label}</span>
    </Tooltip>
  );
};
